import { styled } from '@mui/material/styles';

export const StyledContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  clear: 'both',

  [theme.breakpoints.down('md')]: {
    padding: 0,
  },

  // Do not set page-break-inside:avoid on the whole document — multi-step
  // content taller than one page causes browsers to push it and leave a blank
  // first page. Individual steps still avoid mid-step breaks via StyledBuffer.
}));

export const StyledChkImg = styled('div')(({ theme }) => ({
  width: `calc(50% - ${theme.spacing(2)})`,
  maxWidth: '100%',
  float: 'right',
  padding: theme.spacing(1),
  boxSizing: 'border-box',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    float: 'none',
  },

  '& img': {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
  },

  '@media print': {
    width: '50%',
    float: 'right',
  },
}));

export const StyledContentContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'noImage',
})(({ theme, noImage }) => ({
  minWidth: 0,
  maxWidth: '100%',
  boxSizing: 'border-box',
  ...(noImage
    ? {
        margin: 'auto',
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
        '@media print': {
          margin: 'auto',
          width: '55%',
        },
      }
    : {
        width: '45%',
        float: 'left',
        [theme.breakpoints.down('xl')]: {
          width: '100%',
          float: 'none',
          padding: theme.spacing(1),
        },
        [theme.breakpoints.up('lg')]: {
          padding: theme.spacing(0),
        },
        '@media print': {
          float: 'left',
          width: '45%',
        },
      }),
}));

export const StyledTextContainer = styled('div')({
  width: '100%',
});

export const StyledRow = styled('div', {
  shouldForwardProp: (prop) => prop !== 'centerVertically',
})(({ centerVertically }) => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  ...(centerVertically ? { alignItems: 'center' } : {}),
}));

export const StyledBuffer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(5),
  pageBreakInside: 'avoid',
  width: '100%',
  // Contain floated step image/text without floating the step itself (floats
  // on the step wrapper break print pagination and can insert blank pages).
  display: 'flow-root',
}));

export const StyledTitleStrong = styled('strong', {
  shouldForwardProp: (prop) => prop !== 'longTitle',
})(({ theme, longTitle }) => ({
  fontSize: 18,
  [theme.breakpoints.down('md')]: {
    marginLeft: theme.spacing(1),
  },
  ...(longTitle ? {} : { textTransform: 'capitalize' }),
}));

export const StyledRowText = styled('div')(({ theme }) => ({
  fontSize: 14,

  [theme.breakpoints.up('lg')]: {
    paddingRight: theme.spacing(1),
  },

  '@media print': {
    fontSize: 12,
  },
}));

export const StyledAdditionalText = styled('div')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: 25,
  marginBottom: theme.spacing(2),
}));

export const StyledSubText = styled('div')(({ theme }) => ({
  fontSize: 17,
  marginTop: theme.spacing(1),
}));

export const StyledChecklistName = styled('div')({
  fontWeight: 'bold',
  fontSize: 20,
});
